import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useSellersParameters } from './hooks/useSellersParameters';

interface IAdBannerMicrofrontendSellersContainerProps {
  manifest: IMicrofrontendManifest;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер баннера вторички над выдачей: поставляет параметры места
 * и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendSellersContainer: React.FC<IAdBannerMicrofrontendSellersContainerProps> = ({
  manifest,
  onStub,
  onError,
  onClose,
}) => {
  const parameters = useSellersParameters();

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
